<template>
  <base-page-layout title="Cashback de trade">
    <nextbuy-cashback-locks-table ref="cashbackTable" />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'

export default {
  name: 'CashbackIndex',
  components: {
    BasePageLayout,
    NextbuyCashbackLocksTable: () => import('@/modules/industria/cashback/views/components/NextbuyCashbackLocksTable.vue'),
  },
}
</script>
